'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _TwitterIcon = require('./TwitterIcon');

var _TwitterIcon2 = _interopRequireDefault(_TwitterIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TwitterIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TwitterIcon/index.js
// module id = 287
// module chunks = 11